// app/javascript/projects/components/ProjectsDisplay.jsx

import React, {useCallback} from 'react';

import NewTranscript from './NewTranscript'
import ContentWrapper from './ContentWrapper'
import OnboardingActions from 'actions/OnboardingActions'
import { useCreateTranscript } from '../../hooks/mutations/useCreateTranscript'
import { useToasts } from 'ui/toast'
import introVideo from 'images/onboarding/introgif.mp4'

function NewTranscriptContainer({projectID, isHover, onboardingState, history}) {
  const createTranscriptMutation = useCreateTranscript();
  const { addToast } = useToasts();

  
  const handleSubmit = useCallback((name, body) => {
    if (!projectID) return;

    createTranscriptMutation.mutate({
      projectId: projectID,
      name,
      body
    }, {
      onSuccess: (data) => {
        const transcript = data?.transcript;
        if (transcript?.id && history) {
          history.push(`/transcripts/${transcript.id}`);
        }
      },
      onError: (error) => {
        addToast('Something went wrong. Please refresh and try again.', { appearance: 'error' });
      }
    });
  }, [projectID, history, createTranscriptMutation]);

  const getStartedClick = () => {
    OnboardingActions.getStarted();
  }

  return (
    <ContentWrapper
      loaded={onboardingState.loaded}
      showOnboarding={onboardingState.newTranscriptOnboarding}
      header='Add transcripts and start coding in seconds— as simple as highlighting on paper'
      body='Stay focused on insights and hit your deadlines.'
      onClick={getStartedClick}
      buttonText='Add Transcript'
      intercomArticle={process.env['INTERCOM_ARITCLE_GET_STARTED_VIDEO']}
      helpArticleText='Watch 2 minute video'
      mediaType='video'
      mediaSrc={introVideo}
      intercomArticleId={process.env['INTERCOM_ARTICLE_GET_STARTED_VIDEO']}
    >
      <div style={{ height: "100%" }}>
        <NewTranscript
          isHover={isHover}
          handleSubmit={handleSubmit}
          projectID={projectID}
        />
      </div>
    </ContentWrapper>
  );
}

export default NewTranscriptContainer;
